import Accordion from "@/components/Accordion";
import React from "react";
import { Branding } from "./Branding";
import { Layout } from "./Layout";
import { EyeCatcher } from "./EyeCatcher";
import { Header } from "./Header";
import { WelcomeMessage } from "./WelcomeMessage";
import { Footer } from "./Footer";
import { OfflineStatus } from "./OfflineStatus";
import { InQueueStatus } from "./InQueueStatus";
import { Conversation } from "./Conversation";
import { Notices } from "./Notices";
import { Effects } from "./Effects";
import ChatWindowPreview from "../../Preview/ChatWindowPreview";
import { ChatWindow } from "../../types";
import WcagGuidancePanel from "../../WcagGuidancePanel";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedLogoFile: (file: File | null) => void;
  setStagedGraphicFile: (file: File | null) => void;
  setStagedHeaderBgFile: (file: File | null) => void;
}

export default function Appearance(props: Props) {
  const [selectedScreen, setSelectedScreen] = React.useState("Landing");

  const previewScreens = [
    {
      label: "Landing Screen",
      action: () => setSelectedScreen("Landing"),
      name: "Landing"
    },
    // {
    //   label: "Initial Conversation",
    //   action: () => setSelectedScreen("initialConversation")
    // },
    {
      label: "Conversation List",
      action: () => setSelectedScreen("ConvoList"),
      name: "ConvoList"
    },
    {
      label: "Active Conversation",
      action: () => setSelectedScreen("Conversation"),
      name: "Conversation"
    },
    // {
    //   label: "Pre Chat Survey",
    //   action: () => setSelectedScreen("preChatSurvey")
    // },
    // {
    //   label: "Post Chat Survey",
    //   action: () => setSelectedScreen("postChatSurvey")
    // },
    // {
    //   label: "Offline Status",
    //   action: () => setSelectedScreen("offlineStatus")
    // },
    {
      label: "Waiting",
      action: () => setSelectedScreen("Connecting"),
      name: "Connecting"
    }
    // {
    //   label: "Eye Catcher",
    //   action: () => setSelectedScreen("eyeCatcher")
    // }
  ];

  return (
    <div className="panel flex bg-white rounded-2xl shadow-md w-full border items-start">
      <div className="p-6 pb-8 border-r border-slate-300 w-full min-w-0">
        <div className="text-lg font-medium mb-2">Appearance</div>
        <div className="text-sm font-normal text-slate-600 mb-4">
          Customize the style configuration of your chat window
        </div>
        <label className="flex items-center gap-2 mb-4 text-sm text-slate-700 cursor-pointer select-none">
          <input
            id="enforce-wcag-aa"
            type="checkbox"
            className="w-4 h-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--color-primary)]"
            checked={(props.workingChatWindow.styleConfig?.enforceWcagAa ?? true)}
            onChange={(e) =>
              props.setWorkingChatWindow({
                ...props.workingChatWindow,
                styleConfig: {
                  ...props.workingChatWindow.styleConfig,
                  enforceWcagAa: e.target.checked
                }
              })
            }
          />
          <span>Enforce WCAG AA contrast (recommended)</span>
        </label>
        <WcagGuidancePanel
          wcagEnabled={props.workingChatWindow.styleConfig?.enforceWcagAa ?? true}
        />
        <div className="overflow-auto">
          <Accordion>
            <Branding
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
              setStagedLogoFile={props.setStagedLogoFile}
            />
            <Layout
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            {/* <EyeCatcher onExpanded={() => {}} /> */}
            <Header
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
              setStagedHeaderBgFile={props.setStagedHeaderBgFile}
            />
            <WelcomeMessage
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Footer
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <OfflineStatus
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <InQueueStatus
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
              setStagedGraphicFile={props.setStagedGraphicFile}
            />
            <Conversation
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Notices
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Effects
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
          </Accordion>
        </div>
      </div>
      <div className="w-full sticky top-24 self-start max-h-[calc(100vh-6rem)] overflow-y-auto">
        <ChatWindowPreview
          chatWindow={props.workingChatWindow}
          previewScreens={previewScreens}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </div>
    </div>
  );
}
